import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {InputLabel,} from "@material-ui/core";
import { Button, TextField, FormControl, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import { headerDataSettings } from "../../../data/modules/settings-header";
import { userDetailContext } from "../../../App";
import { useContext } from "react";
import { hasPrivilege } from "../../../utils/privilege";
import { useNavigate } from 'react-router-dom';
import TimeTrackingService from "../../../services/TimeTrackingService";
import ExportExcel from "../../personnel/ExportExcel";
import TimeTrackingTable from "./TimeTrackingTable";
import ImmobilisationService from "../../../services/ImmobilisationService";
import SearchIcon from '@mui/icons-material/Search';
import PlanningService from "../../../services/PlanningService";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import ServiceService from "../../../services/ServiceService";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import UserService from "../../../services/UserService";

const useStyles = makeStyles((theme) => ({

    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
        elevation: 0,
    },
    dialogPaper: {
        borderRadius: 10,
        boxShadow: "0 16px 40px rgba(13, 61, 145, 0.25)",
        minWidth: 360,
    },
    dialogTitle: {
        backgroundColor: "#0b3d91",
        color: "#ffffff",
        fontWeight: 700,
        letterSpacing: 0.2,
    },
    dialogContent: {
        paddingTop: theme.spacing(2),
    },
    dialogText: {
        color: "#1a1a1a",
        fontWeight: 500,
    },
    dialogActions: {
        padding: theme.spacing(2),
        backgroundColor: "#f6f7fb",
    },
    dialogButton: {
        fontWeight: 700,
        textTransform: "none",
    },
}));

export default function TimeTracking(props) {

    const navigate = useNavigate();
    const directionUser = localStorage.getItem("USER_DIR") || 1;
    const contextData = useContext(userDetailContext);
    const [directions, setDirection] = useState([]);
    const today = new Date().toISOString().split('T')[0];
    const [isAdmin, setIsAdmin] = useState(false);
    const [defaultDirectionId, setDefaultDirectionId] = useState(null);
    const [filters, setFilters] = useState({
        direction_id: directionUser,
        date_debut: today,
        date_fin: today,
        nom: '',
        statut: 'Tous',
        service_id: 0,
        registration_number: '',
        type: "all"
    });

    const classes = useStyles();
    const [dateNow, setDateNow] = useState("");
    const [listTimeTracking, setListTimeTrackingToExport] = useState([]);
    const [listTimeTrackingDisplay, setListTimeTrackingToDisplay] = useState([]);
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);
    const [services, setServices] = useState([]);
    const [dateDialogOpen, setDateDialogOpen] = useState(false);

    const fetchTimeTrackingData = (appliedFilters = filters) => {
        const timeStampNow = new Date().toISOString().replace(/[^0-9]/g, '').slice(0, -3);
        setDateNow(timeStampNow);
        setOpenLoadingSimpleBackdrop(true);

        TimeTrackingService.getAllTimeTracking(appliedFilters)
            .then((result) => {
                if (result.status) {
                    setListTimeTrackingToExport(result.data.map((row, index) => ({
                        DIRECTION: row.direction,
                        SERVICE: row.service,
                        MATRICULE: row.registration_number,
                        FONCTION: row.function_name,
                        NOM_PRENOMS: row.Nom_prenom,
                        DATE_POINTAGE: row.Date_d_arrive,
                        ENTREE: row.date == today && row.Entree == 'non' ? 'En attente de synchronisation' : row.Entree,
                        SORTIE: row.date == today && row.Sortie == 'non' ? 'En attente de synchronisation' : row.Sortie,
                        PERIODE: row.Type,
                        HEURE_ENTREE: row.heureetree,
                        HEURE_SORTIE: row.heuresortie,
                        OBSERVATION: row.observation,
                        STATUT: row.date == today && row.Statut == 'Absent' ? 'En attente de synchronisation' : row.Statut,
                    })));
                    setListTimeTrackingToDisplay(
                        result.data
                            .filter(row => row.registration_number && row.registration_number.trim() !== "")
                            .map((row, index) => ({
                                ...row,
                                id: index,
                            }))
                    );

                } else {
                    setListTimeTrackingToExport([]);
                    setListTimeTrackingToDisplay([]);
                }
                setOpenLoadingSimpleBackdrop(false);
            })
            .catch(() => {
                setOpenLoadingSimpleBackdrop(false);
            });
    };

    function handleChangeType(ev) {
        const { name, value } = ev.target;
        setFilters({ ...filters, [name]: value });
    }

    // 👇 Initialisation : charger la direction de l'utilisateur et figer si non-admin
    useEffect(() => {
        const fetchUserDirection = async () => {
            const userData = localStorage.getItem('USER');
            if (userData) {
                try {
                    const result = await UserService.getUserSummaryByUserId(userData);
                    if (result && result.data) {
                        const dirpers = result.data.direction_id;
                        const admin = parseInt(dirpers, 10) === 1;
                        setIsAdmin(admin);

                        if (!admin) {
                            // Non-admin : figer sur sa direction
                            const dirId = parseInt(dirpers, 10);
                            setDefaultDirectionId(dirId);
                            setFilters(prev => ({
                                ...prev,
                                direction_id: dirId,
                                service_id: 0,
                            }));
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user summary:', error);
                }
            }
        };

        fetchUserDirection();
    }, []);

    useEffect(() => {
        // Ne charger les données qu'une fois la direction définie
        if (defaultDirectionId !== null || isAdmin) {
            fetchTimeTrackingData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultDirectionId, isAdmin]);

    useEffect(() => {
        ImmobilisationService.direction().then((result) => {
            if (result && result.data) {
                // Si non-admin, filtrer pour ne garder que sa direction
                if (!isAdmin && defaultDirectionId) {
                    const filtered = result.data.filter(
                        (ts) => parseInt(ts.direction_id, 10) === parseInt(defaultDirectionId, 10)
                    );
                    setDirection(filtered);
                } else {
                    setDirection(result.data);
                }
            }
        });
    }, [isAdmin, defaultDirectionId]);

    useEffect(() => {
        const fetchServices = async (direction_id) => {
            if (direction_id === 0 || direction_id === "") {
                ServiceService.getService().then((results) => {
                    if (results && results.data) {
                        setServices(results.data)
                    }
                })
            }

            if (direction_id !== 0 && direction_id !== "") {
                PlanningService.Direction(direction_id).then((results) => {
                    if (results && results.data) {
                        setServices(results.data);
                    }
                });
            }
        };
        fetchServices(filters.direction_id);
    }, [filters.direction_id]);


    const handleDateDialogClose = () => {
        setDateDialogOpen(false);
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;

        // 🔒 Bloquer le changement de direction pour les non-admins
        if (name === "direction_id" && !isAdmin) {
            return;
        }

        const nextFilters = { ...filters, [name]: value };
        if (
            (name === "date_debut" || name === "date_fin")
            && nextFilters.date_debut
            && nextFilters.date_fin
            && nextFilters.date_debut > nextFilters.date_fin
        ) {
            setDateDialogOpen(true);
            return;
        }
        setFilters(nextFilters);

    };
    const handleSubmit = (event) => {
        event.preventDefault();
        fetchTimeTrackingData(filters);
    };


    const handleexportdata = async (event) => {
        event.preventDefault();

        try {
            const filtered = directions.filter(ts => ts.direction_id === filters.direction_id);
            const nomDirection = filtered.length > 0 ? filtered[0].name : '';

            let datedebut = '';
            let datefins = '';
            let datefinal = '';

            if (filters.date_debut) {
                const debuts = filters.date_debut;
                const tabledebut = debuts.split('-');
                datedebut = `${tabledebut[2]}/${tabledebut[1]}/${tabledebut[0]}`;
            }

            if (filters.date_fin) {
                const fins = filters.date_fin;
                const tablefins = fins.split('-');
                datefins = `${tablefins[2]}/${tablefins[1]}/${tablefins[0]}`;
            }

            if (datedebut && datefins) {
                datefinal = `Pointage du ${datedebut} au ${datefins}`;
            } else if (datedebut) {
                datefinal = `Pointage à partir du ${datedebut}`;
            } else if (datefins) {
                datefinal = `Pointage jusqu'au ${datefins}`;
            }
            if (!listTimeTracking || !Array.isArray(listTimeTracking)) {
                console.error('listTimeTracking is not ready or not an array');
                return;
            }

            const getImageBase64 = async (url) => {
                return new Promise((resolve, reject) => {
                    const img = new Image();
                    img.crossOrigin = 'Anonymous';
                    img.src = url;

                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0);
                        const dataURL = canvas.toDataURL('image/png');
                        resolve(dataURL);
                    };

                    img.onerror = () => {
                        reject(new Error("Image load error"));
                    };
                });
            };

            const base64Logo = await getImageBase64('/assets/images/fid_logo.png');

            const doc = new jsPDF({ orientation: 'landscape' });

            const columns = [
                { headerName: 'Direction', field: 'DIRECTION' },
                { headerName: 'Service', field: 'SERVICE' },
                { headerName: 'Matricule', field: 'MATRICULE' },
                { headerName: 'Nom et prénom(s)', field: 'NOM_PRENOMS' },
                { headerName: 'Date de pointage', field: 'DATE_POINTAGE' },
                { headerName: 'Entrée', field: 'ENTREE' },
                { headerName: 'Sortie', field: 'SORTIE' },
                { headerName: 'Période', field: 'PERIODE' },
                { headerName: 'Observation', field: 'OBSERVATION' },
                { headerName: 'Statut', field: 'STATUT' }
            ];

            const headers = columns.map(col => col.headerName);

            const body = listTimeTracking
                .filter(row => row && row.MATRICULE !== undefined && row.MATRICULE !== "" && row.MATRICULE !== null)
                .map(row => {
                    return columns.map(col => {
                        const value = row[col.field];
                        return value !== null && value !== undefined ? String(value) : '';
                    });
                });

            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();


            doc.setFontSize(16);

            const exportDate = new Date().toLocaleDateString();

            if (body.length > 0) {
                doc.autoTable({
                    head: [headers],
                    body: body,
                    startY: 35,
                    styles: {
                        fontSize: 8,
                        cellPadding: 2,
                        overflow: 'linebreak'
                    },
                    headStyles: {
                        fillColor: [41, 128, 185],
                        textColor: [255, 255, 255],
                        fontStyle: 'bold'
                    },
                    margin: { top: 35 },
                    theme: 'grid',
                    didDrawPage: function (data) {
                        doc.setFontSize(12);
                        doc.setFont(undefined, 'normal');

                        const logoWidth = 20;
                        const logoHeight = 15;
                        const logoX = 10;
                        const logoY = 10;
                        doc.addImage(base64Logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

                        const text1Width = doc.getTextWidth(nomDirection);
                        const x1 = (pageWidth - text1Width) / 2;
                        doc.text(nomDirection, x1, 15);

                        const text2Width = doc.getTextWidth(datefinal);
                        const x2 = (pageWidth - text2Width) / 2;
                        doc.text(datefinal, x2, 25);

                        doc.text(`Exporté le: ${exportDate}`, pageWidth - 70, 10);

                        const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                        doc.text(`Page ${currentPage}`, pageWidth - 30, pageHeight - 10);
                    }
                });
            } else {
                doc.setFontSize(12);
                doc.text('Aucune donnée à exporter', 14, 30);
            }

            doc.save('rapport_pointage.pdf');

        } catch (error) {
            if (error.message.includes('autoTable')) {
                console.error("Erreur liée à autoTable - vérifiez les données:");
                console.log("listTimeTracking:", listTimeTracking);
            }
        }
    };


    function handleClick() {
        const timeStampNow = (new Date()).toISOString().replace(/[^0-9]/g, '').slice(0, -3)
    }

    return (
        <MainContainer {...headerDataSettings}>
            <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
            <Grid container item xs={12}>
                <Spacer x={2} />
                {hasPrivilege(contextData.privileges, "Export_Pointage_avec_heure") && (
                    <ExportExcel dataToExport={listTimeTracking} fileName={"pointage_avec_heure_" + dateNow} title="Exporter en Excel avec heure" color="info" />
                )}
                <Spacer x={2} />
                <ExportExcel dataToExport={listTimeTracking.map(({ FONCTION, HEURE_ENTREE, HEURE_SORTIE, ...rest }) => rest)} fileName={"pointage_" + dateNow} />
                <Spacer x={2} />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleexportdata}
                    style={{ fontWeight: 600 }}
                >
                    Exporter en PDF
                </Button>
                <Spacer x={2} />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    startIcon={<SearchIcon />}
                    style={{ fontWeight: 600 }}
                >
                    Filtrer
                </Button>
                <Spacer x={2} />
            </Grid>
            <Grid container spacing={2} style={{ marginTop: '20px' }}>
                <Grid item xs={12} sm={6} md={3} style={{ marginTop: 'auto' }}>
                    <label className={classes.labelPosition}>
                        Direction:
                    </label>
                    <FormControl fullWidth variant="outlined" size="small">
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="dir"
                            name="direction_id"
                            style={{ width: '300px' }}
                            value={filters.direction_id}
                            onChange={handleChanges}
                            disabled={!isAdmin} // 🔒 Figé pour les non-admins
                        >
                            {hasPrivilege(contextData.privileges, "Pointage_Directions") && isAdmin && (
                                <MenuItem value={0}>
                                    Tous
                                </MenuItem>
                            )}
                            {directions.map((row) => (
                                <MenuItem key={row.direction_id} value={row.direction_id}>
                                    {row.name}({row.code})
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3} style={{ marginTop: 'auto' }}>
                    <label className={classes.labelPosition}>
                        Service:
                    </label>
                    <Spacer y={0.2}></Spacer>
                    <FormControl fullWidth variant="outlined" size="small">
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="service"
                            name="service_id"
                            defaultValue={filters.service_id}
                            style={{ width: '300px' }}
                            onChange={handleChanges}
                        >

                            <MenuItem value={0}>
                                Tous
                            </MenuItem>
                            {services.map((row) => (
                                <MenuItem key={row.service_id} value={row.service_id}>{row.code}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <label className={classes.labelPosition}>
                        Matricule:
                    </label>
                    <Spacer y={0.2}></Spacer>
                    <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        defaultValue={filters.registration_number}
                        name="registration_number"
                        onChange={handleChanges}
                        type="text"
                        style={{ width: '300px' }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3} style={{ marginTop: 'auto' }}>
                    <label className={classes.labelPosition}>
                        Nom et prénom(s):
                    </label>
                    <Spacer y={0.2}></Spacer>
                    <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        name="nom"
                        onChange={handleChanges}
                        type="text"
                        style={{ width: '300px' }}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <label className={classes.labelPosition}>
                        Date début:
                    </label>
                    <Spacer y={0.2}></Spacer>
                    <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        defaultValue={filters.date_debut}
                        name="date_debut"
                        onChange={handleChanges}
                        type="date"
                        style={{ width: '300px' }}
                        inputProps={{
                            max: new Date().toISOString().split('T')[0],
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <label className={classes.labelPosition}>
                        Date Fin:
                    </label>
                    <Spacer y={0.2}></Spacer>
                    <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        name="date_fin"
                        defaultValue={filters.date_fin}
                        onChange={handleChanges}
                        type="date"
                        style={{ width: '300px' }}
                        inputProps={{
                            max: new Date().toISOString().split('T')[0],
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3} style={{ marginTop: 'auto' }}>
                    <label className={classes.labelPosition}>
                        Statut:
                    </label>
                    <Spacer y={0.2}></Spacer>
                    <FormControl fullWidth variant="outlined" size="small">
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="statut"
                            name="statut"
                            defaultValue={filters.statut}
                            style={{ width: '300px' }}
                            onChange={handleChanges}
                        >

                            <MenuItem value="Tous">
                                Tous
                            </MenuItem>
                            <MenuItem value="Absent">
                                Absent
                            </MenuItem>
                            <MenuItem value="Présent">
                                Présent
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <label className={classes.labelPosition}>
                        Type:
                    </label>
                    <FormControl fullWidth variant="outlined" size="small" required>
                        <InputLabel>Type </InputLabel>
                        <Select
                            label="Type"
                            name="type"
                            value={filters.type}
                            onChange={handleChangeType}
                        >
                            <MenuItem value="">
                                <em>Veuillez sélectionner un type</em>
                            </MenuItem>
                            <MenuItem value="all">Tous</MenuItem>
                            <MenuItem value="0">Cadre</MenuItem>
                            <MenuItem value="1">Stagiaire</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            <Spacer y={2} />
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper className={classes.paper} variant="outlined">
                        <TimeTrackingTable rows={listTimeTrackingDisplay} />
                    </Paper>
                </Grid>
            </Grid>
            <Dialog
                open={dateDialogOpen}
                onClose={handleDateDialogClose}
                aria-labelledby="date-range-dialog-title"
                classes={{ paper: classes.dialogPaper }}
            >
                <DialogTitle id="date-range-dialog-title" className={classes.dialogTitle}>
                    Intervalle de dates invalide
                </DialogTitle>
                <DialogContent className={classes.dialogContent} dividers>
                    <Typography variant="body1" className={classes.dialogText}>
                        La date de debut doit etre inferieure ou egale a la date de fin.
                    </Typography>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <Button
                        onClick={handleDateDialogClose}
                        color="primary"
                        variant="contained"
                        className={classes.dialogButton}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </MainContainer>
    );
}